/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Taxonomy_Index_Collection_TitleInputs */

const en_directory_taxonomy_index_collection_title = /** @type {(inputs: Directory_Taxonomy_Index_Collection_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Follow a curated product path`)
};

const zh_directory_taxonomy_index_collection_title = /** @type {(inputs: Directory_Taxonomy_Index_Collection_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`沿着精选路径发现产品`)
};

/**
* | output |
* | --- |
* | "Follow a curated product path" |
*
* @param {Directory_Taxonomy_Index_Collection_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_taxonomy_index_collection_title = /** @type {((inputs?: Directory_Taxonomy_Index_Collection_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Taxonomy_Index_Collection_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_taxonomy_index_collection_title(inputs)
	return zh_directory_taxonomy_index_collection_title(inputs)
});
export { directory_taxonomy_index_collection_title as "directory.taxonomy_index.collection.title" }